import dayjs from 'dayjs';


// format date as YYYY-MM-DD
export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const isValidDateString = (dateString) => {
    // Matches "YYYY-MM-DD"
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime()) && date.toISOString().startsWith(dateString);
};

// format time as HH:MM:SS
export const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
};

// Convert "HH:MM:SS" to "HH:MM AM/PM"
export const formatToDisplayTime = (time) => {
    let [hour, minute] = time.split(":").map(Number);
    let period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 24-hour to 12-hour format
    return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${period}`;
};

export const addSeconds = (time) => {
    if (!time.includes(':')) return time; // Return as-is if the input doesn't have a valid time format
    const parts = time.split(':');
    const hasSeconds = parts.length === 3; // Check if time is in HH:MM:SS format
    return hasSeconds ? time : `${time}:00`; // Add seconds if missing
};

// Utility function to format time string to a dayjs object
export const formatTimeToDayjs = (timeString) => {
    const [time, period] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;

    return dayjs().hour(hours).minute(minutes).second(0).millisecond(0);
};

